import classNames from 'classnames'
import * as React from 'react'
import { Label as RechartsLabel } from 'recharts'

import { CHART_ITEM_COLORS, ChartItemColorType } from './constants'

interface LabelInnerProps extends LabelProps {
  dx?: number
  dy?: number
  viewBox?: { x: number; y: number; width: number; height: number }
  color?: ChartItemColorType
}

function LabelInner({
  color,
  viewBox,
  dx = 0,
  dy = 0,
  angle = -90,
  children,
  ...props
}: React.PropsWithChildren<LabelInnerProps>) {
  if (!viewBox) return

  const x = viewBox.x + viewBox.width / 2 + dx
  const y = viewBox.y + viewBox.height / 2 + dy

  return (
    <text
      {...props}
      fontSize={10}
      fontWeight={500}
      textAnchor="middle"
      dominantBaseline="central"
      className="stroke-bg-primary stroke-2 [paint-order:stroke_fill]"
      style={{ transform: `translate(${x}px, ${y}px) rotate(${angle}deg)` }}
    >
      {color && <tspan className={classNames(CHART_ITEM_COLORS[color], 'fill-current')}>● </tspan>}
      <tspan className="fill-gray-500 dark:fill-gray-300">{children}</tspan>
    </text>
  )
}

interface LabelProps extends React.PropsWithoutRef<React.ComponentProps<typeof RechartsLabel>> {
  color?: ChartItemColorType
}

export function Label({ children, color, ...props }: LabelProps) {
  return <RechartsLabel content={<LabelInner children={children} color={color} />} {...props} />
}

Label.displayName = RechartsLabel.displayName
